import { get, put } from './';

export const getOrganizationCountry = (organizationId, countryId) => {
  return get(
    `/api/internal/organizations/${organizationId}/countries/${countryId}`,
  );
};

export const updateOrganizationCountry = (
  organizationId,
  countryId,
  emails,
) => {
  return put(
    `/api/internal/organizations/${organizationId}/countries/${countryId}`,
    {
      bookingReceptionEmails: emails,
    },
  );
};
